import React from 'react';

const InfoArteFinalPrice = ({ children }) => {
  return <p className="item-arte-final-price">{children}</p>;
};

export default InfoArteFinalPrice;
